import React from "react";
import { SkeletonLoader, TextButton } from "@SeemplicityDev/shared";
import type { AnalystInstanceBase } from "../../../AnalystRuns/types";

interface AgentConfigsListProps {
  configs: AnalystInstanceBase[];
  isLoading: boolean;
  isError: boolean;
  onEdit: (row: AnalystInstanceBase) => void;
}

const AgentConfigsList: React.FC<AgentConfigsListProps> = ({
  configs,
  isLoading,
  isError,
  onEdit,
}) => {
  return (
    <div className="account-configs-list">
      <div className="account-configs-list-header">
        <h4 className="account-configs-subtitle">Configs</h4>
      </div>

      {isLoading ? (
        <ul
          className="account-configs-rows"
          data-testid="account-configs-loading"
        >
          {Array.from({ length: 4 }, (_, index) => (
            <li className="account-configs-row" key={`skeleton-${index}`}>
              <div className="account-configs-row-main">
                <SkeletonLoader height="19px" width="60%" />
                <SkeletonLoader height="14px" width="35%" />
              </div>
              <div className="account-configs-row-integrations">
                <SkeletonLoader height="14px" width="80%" />
              </div>
            </li>
          ))}
        </ul>
      ) : isError ? (
        <p className="account-configs-error">
          Failed to load account configs. Please try again.
        </p>
      ) : !configs.length ? (
        <p className="account-configs-empty">
          No configs yet. Create one to get started.
        </p>
      ) : (
        <ul className="account-configs-rows">
          {configs.map((config) => (
            <li
              className="account-configs-row"
              key={config.agent_instance_id}
              data-testid={`account-configs-row-${config.agent_instance_id}`}
            >
              <div className="account-configs-row-main">
                <span className="account-configs-row-name">
                  {config.display_name}
                </span>
                <span className="account-configs-row-type">
                  {config.agent_type_label}
                </span>
              </div>
              <div className="account-configs-row-integrations">
                {!config.integrations?.length
                  ? "No integrations"
                  : `${config.integrations.length} integration${
                      config.integrations.length === 1 ? "" : "s"
                    }: ${config.integrations
                      .map((integration) => integration.display_name)
                      .join(", ")}`}
              </div>
              <TextButton
                type="button"
                data-testid={`account-configs-edit-${config.agent_instance_id}`}
                label="Edit"
                onClick={() => onEdit(config)}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AgentConfigsList;
